import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/workpath0/node_modules/gatsby-theme-docz/src/base/Layout.js";
import Subscribe from "./src/Subscribe";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "label-bounding-boxes-with-the-universal-data-tool"
    }}>{`Label Bounding Boxes with the Universal Data Tool`}</h1>
    <p>{`Labeling your data with bounding boxes is an essential first step before training a machine learning algorithm. The `}<a parentName="p" {...{
        "href": "https://universaldatatool.com"
      }}>{`Universal Data Tool`}</a>{` is a free, open-source application that makes this process simple.`}</p>
    <p>{`Before you start, you should have either...`}</p>
    <ul>
      <li parentName="ul">{`A directory of images`}</li>
      <li parentName="ul">{`A file where each line is an image url (this is what I'll use)`}</li>
    </ul>
    <h2 {...{
      "id": "configure-the-job"
    }}>{`Configure the Job`}</h2>
    <p>{`To begin navigate to `}<a parentName="p" {...{
        "href": "https://universaldatatool.com"
      }}>{`universaldatatool.com`}</a>{` or download the `}<a parentName="p" {...{
        "href": "https://github.com/UniversalDataTool/universal-data-tool/releases"
      }}>{`latest release from github`}</a>{`. I'll use the web version for now.`}</p>
    <p><img alt="homepage of udt" src={require("./assets/udt/home.png")} /></p>
    <p>{`Click "Create from Template" and select Computer Vision, then configure it to only do bounding boxes. If you also want to label each bounding box with a classification, you can also configure that here.`}</p>
    <p><img alt="udt computer vision configure" src={require("./assets/udt/computer-vision-configure.png")} /></p>
    <h2 {...{
      "id": "import-the-data"
    }}>{`Import the Data`}</h2>
    <p>{`Navigate to "Samples", then to the "Import" page. Click "Paste Image URLs", paste the image urls and click "Add Samples".`}</p>
    <p><img alt="udt sample grid" src={require("./assets/udt/imported-samples.png")} /></p>
    <h2 {...{
      "id": "label-the-data"
    }}>{`Label the Data`}</h2>
    <p>{`You can now begin labeling. Click the "Label" button at the top, then click on any sample to begin. Samples will turn blue as they're labeled.`}</p>
    <p><img alt="label hand" src={require("./assets/udt/label-hand.png")} /></p>
    <p><img alt="some completed" src={require("./assets/udt/some-samples-completed.png")} /></p>
    <h2 {...{
      "id": "wrapping-up"
    }}>{`Wrapping Up`}</h2>
    <p>{`When you're done, navigate to the "Settings" tab and click Download JSON. The resulting file can be loaded into the Universal Data Tool again, or parsed for usage with a machine learning algorithm.`}</p>
    <p>{`That's it! You now have everything you need to add bounding boxes to a image dataset.`}</p>

    <Subscribe mdxType="Subscribe" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      